import { modalCreateActions } from 'app/store/modal/modalSlice'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'

import React, { PureComponent } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { MODAL_NAME } from '../../../commons/constants/modal.const'
import './modalConfirm.scss'

class ModalConfirm extends PureComponent {
  renderNotificationWarning() {
    const {
      notificationContent: { content, notification },
    } = this.props
    return (
      <div className="bg-yellow-xxxl border-yellow-l text-center radius4 mt15">
        {content && <div className="pt20 pb20 pr80 pl80 fs18">{content}</div>}
        {notification && <div className="pt7 pb7 pr40 pl40 border-t-yellow-l bg-yellow-xl">{notification}</div>}
      </div>
    )
  }

  render() {
    const {
      showClose,
      header,
      content,
      text,
      footer,
      cancel,
      confirm,
      type,
      notificationContent,
      cancel: { cbClose },
      actions,
    } = this.props
    return (
      <div className="Popup">
        <div className="Popup-Container">
          <div className="Popup-Header">{header}</div>
          <div className="Popup-Close">
            {showClose && (
              <i
                onClick={() => {
                  actions.closeModal()
                  cbClose && cbClose()
                }}
                className="material-icons"
                role="presentation"
              >
                close
              </i>
            )}
          </div>
          <div className="Popup-Body text-center pl30 pr30 ">
            {type && type === MODAL_NAME.NOTIFICATION_WARNING && notificationContent
              ? this.renderNotificationWarning()
              : content && <div className="fs18 mt20">{content}</div>}
            {text && <div className="fs22 f-robo-b mt15 text-gray">{text}</div>}
            <div className="text-center mt30 mb20 fs20 f-robo-m">
              {cancel && cancel.text && (
                <button
                  onClick={() => cancel.action()}
                  type="button"
                  className={`Button pl20 pr20 transparent min-w140 mr20 ${cancel.type}`}
                >
                  {cancel.text}
                </button>
              )}
              {confirm && confirm.text && (
                <button
                  onClick={() => confirm.action()}
                  type="button"
                  className={`Button pl20 pr20 dark-green min-w140 ${confirm.type}`}
                >
                  {confirm.text}
                </button>
              )}
            </div>
            {footer && <div className="mb20 fs12 text-gray-l">{footer}</div>}
          </div>
        </div>
      </div>
    )
  }
}

ModalConfirm.propTypes = {
  type: PropTypes.string,
  header: PropTypes.string,
  showClose: PropTypes.bool,
  content: PropTypes.string,
  notificationContent: PropTypes.object,
  text: PropTypes.string,
  cancel: PropTypes.shape({
    text: PropTypes.string,
    type: PropTypes.string,
    action: PropTypes.func,
  }),
  confirm: PropTypes.shape({
    text: PropTypes.string,
    type: PropTypes.string,
    action: PropTypes.func,
  }),
  footer: PropTypes.string,
}

ModalConfirm.defaultProps = {
  header: '',
  showClose: false,
  content: '',
  notificationContent: {},
  text: '',
  cancel: {},
  confirm: {},
  footer: '',
  type: '',
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...modalCreateActions }, dispatch),
})

export default withTranslation()(connect(null, mapDispatchToProps)(ModalConfirm))
